<template>
  <section class="recipe__ingredients">
    <section v-for="(section, index) in sections" :key="`section-${index}`">
      <h5 class="mui-list-section" v-if="section.title">{{section.title.replace(/\:$/, '')}}</h5>
      <ul class="mui-list mui-list--static">
        <Ingredient
          v-for="item in section.items"
          :data-item-key="item.key"
          :data-item-priority="item.priority"
          :id="`ingredient-${item.key}`"
          :key="item.key"
          :scale="scale"
          v-bind="item"></Ingredient>
      </ul>
    </section>
  </section>
</template>

<script>
import Ingredient from '@/components/Recipe/Ingredient'
import { splitObjectByProperty } from '@/utils'
export default {
  components: {
    Ingredient
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    scale: String
  },
  computed: {
    sections () {
      return splitObjectByProperty(this.items.filter(el => el.text), 'section')
    }
  }
}
</script>

<style lang="sass">
@import "../../styles/variables.scss"
.recipe__ingredients
  .mui-list
    padding-left: 0
    margin-top: 0
  .mui-list-item
    display: block
    padding-left: 0
    font-size: 16px
    line-height: 26px
    .debug--original
      display: block
      color: #999
      font-size: 14px
  h5.mui-list-section
    margin-bottom: 7px
    text-transform: uppercase
    font-weight: 600
    &.mui-position--first
      margin-top: 0
  .panel--instructions &
    .device__viewport-class--regular &
      margin-left: -29px

  > section
    h5
      margin-bottom: 0
      text-transform: uppercase
      font-weight: 600
      font-size: 16px
      line-height: 26px
    &:first-child h5
      margin-top: 0
</style>



// WEBPACK FOOTER //
// src/components/Recipe/Ingredients.vue